'use strict';
export default {
  appName: '悟空图像',
  errorCode: {
    code12: 'token错误',
    code115: '账号不存在',
    code117: '密码错误',
    code118: '手机号格式错误',
    code123: '验证码错误',
  },
  // components--------------------------------------------------------------------------------------------------
  login: {
    codeLogin: '验证码登录',
    accountLogin: '账号密码登录',
    apply: '注册',
    inputPhone: '请输入手机号',
    inputCode: '请输入验证码',
    getCode: '获取验证码',
    login: '登录',
    inputAccount: '请输入账号',
    inputPassword: '请输入密码',
    thirdPartyLogin: '第三方登录',
    loginAgreement: '登录即视为同意',
    agreement: '悟空图像软件使用许可及服务协议',
    and: '和',
    policy: '隐私政策',
    privacyPolicyUrl: '/static/privacy_policy_zh-cn.html',
    userAgreementUrl: '/static/user_agreement_zh-cn.html',
    close: '关 闭',
    charactersLong: '长度在11个字符',
    accountCannotBeEmpty: '账号不能为空',
    loginSucceeded: '登录成功',
    codeError: '错了哦，验证码输入错误！',
    tip: '提示',
    logoutTip: '此操作将退出登录，是否继续？',
    confirm: '确定',
    cancel: '取消',
    personalCenter: "个人中心",
    LogOut:'退出登录！'
  },
  userCenter: {
    url: 'https://user.photosir.com/#/front/Personal/PersonalInformation?token='
  },
};



// WEBPACK FOOTER //
// ./src/language/config/zh-CN.js